import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { ChevronDown } from '@outdoor-voices/ui';
import { isMobile } from '@outdoor-voices/ui/dist/utils/dom/isMobile';
import { KEY_CODES, KEY_DOWN } from '@outdoor-voices/ui/dist/config/constants';
import { lockScroll, unlockScroll } from '@outdoor-voices/ui/dist/utils/dom/scroll';
import cc from 'classcat';
import PropTypes from 'prop-types';
import React, { Component, createRef, forwardRef } from 'react';
import ReactDOM from 'react-dom';
import { getSizeVerbose } from '../../config/constants-sizes';
import { SCROLL } from '../../config/constants';
import Button from '../Button';
import Check from '../icons/Check';
import css from './SelectAdvanced.module.scss'; // import smoothScroll from '../../utils/dom/smoothScroll';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var Message = function Message(_ref) {
  var disabled = _ref.disabled,
      onClick = _ref.onClick,
      optMessage = _ref.optMessage,
      selectedValue = _ref.selectedValue,
      value = _ref.value;
  var checked = !disabled && value === selectedValue;
  var hasMessage = !!optMessage && !onClick;

  if (hasMessage && checked) {
    return /*#__PURE__*/_jsxs("span", {
      className: cc([css.optionDetail, css.checked]),
      children: [optMessage, /*#__PURE__*/_jsx(Check, {
        className: css.check
      })]
    });
  }

  if (!hasMessage) {
    return checked && /*#__PURE__*/_jsx(Check, {
      className: css.check
    });
  }

  return hasMessage && /*#__PURE__*/_jsx("span", {
    className: css.optionDetail,
    children: optMessage
  });
};

Message.defaultProps = {
  disabled: false,
  onClick: null,
  optMessage: '',
  selectedValue: null
};
Message.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  optMessage: PropTypes.string,
  selectedValue: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]).isRequired
};
/* eslint-disable react/no-array-index-key */

var DropDown = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var actionLabel = _ref2.actionLabel,
      close = _ref2.close,
      createPortal = _ref2.createPortal,
      compact = _ref2.compact,
      id = _ref2.id,
      label = _ref2.label,
      left = _ref2.left,
      onActionClick = _ref2.onActionClick,
      onChange = _ref2.onChange,
      open = _ref2.open,
      options = _ref2.options,
      top = _ref2.top,
      maxWidth = _ref2.maxWidth,
      value = _ref2.value;
  var inlineStyle = createPortal ? {
    left: left,
    top: top,
    maxWidth: maxWidth
  } : null;

  var dropDown = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("button", {
      "aria-hidden": !open,
      "aria-label": "Close ".concat(label, " Select"),
      className: cc([css.bg, _defineProperty({}, css.on, open)]),
      onClick: close,
      tabIndex: open ? 0 : -1,
      title: "Close ".concat(label, " Select"),
      type: "button"
    }), /*#__PURE__*/_jsxs("div", {
      "aria-hidden": open ? 'false' : 'true',
      className: cc([css.dropdown, _defineProperty({}, css.on, open), _defineProperty({}, css.compact, compact), _defineProperty({}, css.portal, !createPortal)]),
      ref: ref,
      style: inlineStyle,
      children: [!compact && /*#__PURE__*/_jsx("div", {
        className: css.label,
        children: label
      }), /*#__PURE__*/_jsx("div", {
        className: css.listWrap,
        children: /*#__PURE__*/_jsx("div", {
          className: cc([css.list, _defineProperty({}, css.compact, compact)]),
          role: "listbox",
          id: id,
          tabIndex: open ? 0 : -1,
          children: options.map(function (option, idx) {
            var adaLabel = getSizeVerbose(option.label);
            return /*#__PURE__*/_jsxs("div", {
              className: css.item,
              children: [/*#__PURE__*/_jsxs("button", {
                "aria-label": option.disabled ? "".concat(adaLabel, " unavailable") : "Select ".concat(adaLabel),
                "aria-selected": option.value === value,
                className: cc([css.button, _defineProperty({}, css.disabled, option.disabled)]),
                disabled: option.disabled,
                onClick: function onClick() {
                  onChange(option.value);
                },
                role: "option",
                tabIndex: open ? 0 : -1,
                type: "button",
                children: [/*#__PURE__*/_jsx("span", {
                  className: css.optionLabel,
                  children: option.label
                }), /*#__PURE__*/_jsx(Message, _objectSpread(_objectSpread({}, option), {}, {
                  selectedValue: value
                }))]
              }), option.optMessage && option.onClick && /*#__PURE__*/_jsx(Button, {
                "aria-label": option.optAriaLabel,
                className: css.optionDetailCta,
                linkStyle: true,
                onClick: function onClick() {
                  close();
                  option.onClick();
                },
                tabIndex: open ? 0 : -1,
                children: option.optMessage
              })]
            }, "".concat(idx));
          })
        })
      }), !compact && /*#__PURE__*/_jsx("button", {
        className: css.actionButton,
        onClick: onActionClick,
        type: "button",
        tabIndex: open ? 0 : -1,
        children: actionLabel
      })]
    })]
  });

  if (!createPortal) {
    return dropDown;
  }

  return /*#__PURE__*/ReactDOM.createPortal(dropDown, document.body);
});
DropDown.defaultProps = {
  actionLabel: '',
  compact: false,
  createPortal: true,
  onActionClick: function onActionClick() {}
};
DropDown.propTypes = {
  actionLabel: PropTypes.string,
  compact: PropTypes.bool,
  createPortal: PropTypes.bool,
  close: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  maxWidth: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  onActionClick: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  value: PropTypes.string.isRequired,
  left: PropTypes.number.isRequired,
  open: PropTypes.bool.isRequired,
  top: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};

var SelectAdvanced = /*#__PURE__*/function (_Component) {
  _inherits(SelectAdvanced, _Component);

  var _super = _createSuper(SelectAdvanced);

  function SelectAdvanced(props) {
    var _this;

    _classCallCheck(this, SelectAdvanced);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onFocus", function () {
      document.addEventListener(KEY_DOWN, _this.onKeyDownFocused, false);
    });

    _defineProperty(_assertThisInitialized(_this), "onBlur", function () {
      document.removeEventListener(KEY_DOWN, _this.onKeyDownFocused);
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyDownFocused", function (event) {
      switch (event.key) {
        case KEY_CODES.ARROW_DOWN:
        case KEY_CODES.ARROW_UP:
          event.preventDefault();

          _this.open();

          break;

        default:
          break;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (event) {
      var ARROW_DOWN = KEY_CODES.ARROW_DOWN,
          ARROW_LEFT = KEY_CODES.ARROW_LEFT,
          ARROW_RIGHT = KEY_CODES.ARROW_RIGHT,
          ARROW_UP = KEY_CODES.ARROW_UP,
          ESC = KEY_CODES.ESC,
          TAB = KEY_CODES.TAB;

      switch (event.key) {
        case ARROW_LEFT:
        case ARROW_UP:
          event.preventDefault();

          _this.focusOption(-1);

          break;

        case ARROW_DOWN:
        case ARROW_RIGHT:
          event.preventDefault();

          _this.focusOption(1);

          break;

        case ESC:
          _this.close();

          break;

        case TAB:
          event.preventDefault();
          break;

        default:
          break;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onScroll", function () {
      _this.setState(_objectSpread({}, _this.getBoundingStyles()));
    });

    _defineProperty(_assertThisInitialized(_this), "getBoundingStyles", function () {
      var createPortal = _this.props.createPortal;

      if (!createPortal || isMobile()) {
        return {
          left: 24,
          maxWidth: 1000,
          top: '50%'
        };
      }

      var offsetPx = 24;
      var _this$dropdownRef$cur = _this.dropdownRef.current,
          offsetWidth = _this$dropdownRef$cur.offsetWidth,
          offsetHeight = _this$dropdownRef$cur.offsetHeight;

      var _this$rootRef$current = _this.rootRef.current.getBoundingClientRect(),
          left = _this$rootRef$current.left,
          top = _this$rootRef$current.top,
          width = _this$rootRef$current.width;

      var currLeft = Math.min(left, window.innerWidth - offsetWidth);
      var currTop = Math.max(Math.min(top, window.innerHeight - offsetHeight), offsetPx * 4);
      return {
        left: currLeft,
        maxWidth: width,
        top: currTop
      };
    });

    _defineProperty(_assertThisInitialized(_this), "close", function () {
      document.removeEventListener(KEY_DOWN, _this.onKeyDown);
      document.removeEventListener(SCROLL, _this.onScroll);

      _this.setState({
        open: false
      });

      if (isMobile()) {
        unlockScroll();
      }

      if (_this.rootRef.current) {
        _this.rootRef.current.querySelector('button').focus();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "open", function () {
      var createPortal = _this.props.createPortal;
      var open = _this.state.open;

      if (open) {
        return;
      }

      if (createPortal && !isMobile()) {
        document.addEventListener(SCROLL, _this.onScroll, {
          passive: true
        });
      }

      if (isMobile()) {
        lockScroll();
      }

      document.addEventListener(KEY_DOWN, _this.onKeyDown, false);

      _this.setState(_objectSpread({
        open: true
      }, _this.getBoundingStyles()));

      setTimeout(_this.focus, 150);
    });

    _defineProperty(_assertThisInitialized(_this), "focus", function () {
      var current = _this.dropdownRef.current;

      if (!current) {
        return;
      }

      var selected = current.querySelector('[aria-selected="true"] button');
      var target = selected || current.querySelector('button:not(:disabled)');
      target.focus();
    });

    _defineProperty(_assertThisInitialized(_this), "focusOption", function (dir) {
      var buttons = _this.dropdownRef.current.querySelectorAll('button:not(:disabled)');

      var items = Array.from(buttons);
      var index = Math.max(0, Math.min(items.indexOf(document.activeElement) + dir, buttons.length - 1));
      buttons[index].focus();
    });

    _defineProperty(_assertThisInitialized(_this), "select", function (variantId) {
      var onChange = _this.props.onChange;
      onChange(variantId);

      _this.close();
    });

    _defineProperty(_assertThisInitialized(_this), "toggle", function () {
      var open = _this.state.open;

      if (open) {
        _this.close();
      } else {
        _this.open();
      }
    });

    _this.rootRef = /*#__PURE__*/createRef();
    _this.dropdownRef = /*#__PURE__*/createRef();
    _this.state = {
      left: 0,
      maxWidth: 0,
      open: false,
      top: 0
    };
    return _this;
  }

  _createClass(SelectAdvanced, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.close();
    }
  }, {
    key: "render",
    value: function render() {
      var _cc;

      var _this$props = this.props,
          actionLabel = _this$props.actionLabel,
          createPortal = _this$props.createPortal,
          compact = _this$props.compact,
          itemDisabledLabel = _this$props.itemDisabledLabel,
          id = _this$props.id,
          label = _this$props.label,
          onActionClick = _this$props.onActionClick,
          options = _this$props.options,
          short = _this$props.short,
          value = _this$props.value;
      var _this$state = this.state,
          left = _this$state.left,
          open = _this$state.open,
          top = _this$state.top,
          maxWidth = _this$state.maxWidth;
      var selectedOption = value ? options.find(function (option) {
        return option.value === value;
      }) : {};
      var valueLabel = value && selectedOption ? selectedOption.label : label;
      return /*#__PURE__*/_jsxs("div", {
        className: css.root,
        ref: this.rootRef,
        children: [/*#__PURE__*/_jsx(Button, {
          "aria-controls": id,
          "aria-expanded": open,
          "aria-haspopup": "listbox",
          "aria-label": label,
          bordered: compact,
          id: "".concat(id, "-button"),
          className: cc((_cc = {}, _defineProperty(_cc, css.compactButton, compact), _defineProperty(_cc, css.shortButton, short), _cc)),
          iconRight: /*#__PURE__*/_jsx(ChevronDown, {}),
          onBlur: this.onBlur,
          onClick: this.toggle,
          onFocus: this.onFocus,
          role: "combobox",
          children: selectedOption && selectedOption.disabled ? label : valueLabel
        }), /*#__PURE__*/_jsx(DropDown, {
          actionLabel: actionLabel,
          createPortal: createPortal,
          close: this.close,
          compact: compact,
          itemDisabledLabel: itemDisabledLabel,
          id: id,
          label: label,
          left: left,
          onActionClick: onActionClick,
          onChange: this.select,
          open: open,
          options: options,
          ref: this.dropdownRef,
          top: top,
          maxWidth: maxWidth,
          value: value
        })]
      });
    }
  }]);

  return SelectAdvanced;
}(Component);

SelectAdvanced.defaultProps = {
  actionLabel: '',
  compact: false,
  createPortal: true,
  onActionClick: function onActionClick() {},
  short: false
};
SelectAdvanced.propTypes = {
  actionLabel: PropTypes.string,
  compact: PropTypes.bool,
  createPortal: PropTypes.bool,
  id: PropTypes.string.isRequired,
  itemDisabledLabel: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onActionClick: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  short: PropTypes.bool,
  value: PropTypes.string.isRequired
};
export default SelectAdvanced;